import {
  knowYourRightsMenu,
  productsMenu,
  companyMenu,
  supportMenu,
  legalMenu,
  topMenu,
  imprintMenu,
} from "config/menus";
import { useServerSideStoryblokPages } from "contexts/DataContext/hooks";
import getPageUrl from "./getPageUrl";
import { getParentLanguage } from "./localeUtils";

const DEFAULT_FALLBACK_LANGUAGE = "en";
const NON_OVERBOOKING_PAGE_IN_MENU_LANGUAGES = ["pt-pt", "pt-br", "ro", "sv", "fi", "nb", "ru", "el"];

export const getStoryblokMenuHref = (storyblokId, serverSideStoryblokPages, language, parentLanguage, fallback) =>
  serverSideStoryblokPages[storyblokId][language] ||
  serverSideStoryblokPages[storyblokId][parentLanguage] ||
  serverSideStoryblokPages[storyblokId][fallback] ||
  serverSideStoryblokPages[storyblokId][DEFAULT_FALLBACK_LANGUAGE] ||
  "";

const resolveMenuPagePaths = (language, menu) => {
  const serverSideStoryblokPages = useServerSideStoryblokPages();
  const parentLanguage = getParentLanguage(language);

  return menu.map((item) => {
    const { storyblokId, fallback, page, subMenu } = item;

    if (storyblokId) {
      return {
        href: getStoryblokMenuHref(storyblokId, serverSideStoryblokPages, language, parentLanguage, fallback),
        ...item,
      };
    }

    if (Object.prototype.hasOwnProperty.call(item, "subMenu")) {
      return {
        ...item,
        subMenu: resolveMenuPagePaths(language, subMenu),
      };
    }

    return {
      href: getPageUrl(language, page),
      ...item,
    };
  });
};

export const useKnowYourRightsMenu = (language) => {
  let menu = knowYourRightsMenu;
  menu = NON_OVERBOOKING_PAGE_IN_MENU_LANGUAGES.includes(language)
    ? menu.filter((item) => item.storyblokId !== 71636186)
    : menu;
  menu = ["el", "ru"].includes(language) ? menu.filter((item) => item.page !== "airports") : menu;

  return resolveMenuPagePaths(language, menu);
};

export const useProductsMenu = (language) => resolveMenuPagePaths(language, productsMenu);

export const useCompanyMenu = (language) => resolveMenuPagePaths(language, companyMenu);

export const useSupportMenu = (language) => {
  const ourFeesId = 142848538;
  const priceListId = 52702007;
  const notTranslatedOurFeesPages = ["da", "pt-br", "ro-md"];

  let menu = supportMenu;

  menu = notTranslatedOurFeesPages.includes(language)
    ? menu.filter((item) => item.storyblokId !== ourFeesId)
    : menu.filter((item) => item.storyblokId !== priceListId);

  return resolveMenuPagePaths(language, menu);
};

export const useLegalMenu = (language) => resolveMenuPagePaths(language, legalMenu);

export const useTopMenu = (language) => {
  const menu = topMenu;
  const knowYourRightsMenuMapped = useKnowYourRightsMenu(language);

  menu.map((item) => {
    const menuItem = item;
    if (menuItem.subMenu) menuItem.subMenu = knowYourRightsMenuMapped;

    return menuItem;
  });

  return resolveMenuPagePaths(language, menu);
};

export const useImprintMenu = (language) => {
  let menu = imprintMenu;
  menu = ["en", "de"].includes(getParentLanguage(language))
    ? menu
    : menu.filter((item) => item.storyblokId !== 52883090);

  return resolveMenuPagePaths(language, menu);
};
